import type { ProductApplicationDTO } from '../api/types';
import type { ApplicationType, ProductApplication } from '../model/types';

export const mapProductApplication = (
  dto: ProductApplicationDTO,
): ProductApplication => {
  return {
    id: dto.id,
    platform: dto.platform as ApplicationType,
    webUrl: dto.webUrl,
    bundleId: dto.bundleId,
    name: dto.name,
    logoUrl: dto.logoUrl,
    productId: dto.productId,
    appstoreId: dto.appstoreId,
    integrationId: dto.integrationId,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
